import { Dayjs } from 'dayjs';
import { useMemo } from 'react';

export default function useDaysNumber(
  startDate: Dayjs | undefined,
  endDate: Dayjs | undefined,
) {
  return useMemo(() => {
    if (!endDate) {
      return 5;
    }
    if (startDate?.isSame(endDate, 'day')) {
      return 1;
    }

    return endDate.diff(startDate, 'day') + 1;
  }, [startDate, endDate]);
}
